var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgParlament(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "55px",
    height: "45px",
    viewBox: "0 0 55 45",
    style: {
      enableBackground: "new 0 0 55 45"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#7B7768;stroke-width:0.5;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "12.4063,35.1152 12.4063,33.1647 20.3619,33.1647 20.3623,33.1647 20.3626,33.1647 33.3391,33.1647  33.3395,33.1647 33.3399,33.1647 42.5938,33.1647 42.5938,35.1152  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "37.2671,32.1294 37.2671,29.5307 35.5646,27.7387 35.5646,22.9496 19.4355,22.9496 19.4355,27.7387  17.7331,29.5307 17.7331,32.1294  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.2836,32.1294l6.4141-1.9829c0.0149-0.0047,0.0299-0.0014,0.0448-0.0047 c0.0363-0.0078,0.0719-0.0111,0.1098-0.0109c0.0349,0.0002,0.0674,0.0033,0.1009,0.0104c0.017,0.0035,0.0337-0.0002,0.0507,0.0052 l6.4143,1.9829"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.1274,32.1294 3.1274,27.9179 2.5,26.3945 3.1274,26.3945 11.3711,26.3945 11.9983,26.3945  11.3711,27.9179 11.3711,32.1294  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.1274,42.607 3.1274,36.1505 11.3711,36.1505  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7.7953,20.7072c2.6141,0.3449,3.3149,3.109,3.5038,4.652"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M3.1987,25.3592c0.1978-1.6203,0.9591-4.5882,3.9065-4.6869"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "35.5646,21.9143 36.2815,20.6597 36.2815,18.9573 35.5646,17.7924 19.4355,17.7924 18.7187,18.9573  18.7187,20.6597 19.4355,21.9143  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M33.9636,20.9139c-0.0681-0.0379-6.7171-3.9228-12.9167-0.0055"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.6408,16.7572c0.4503-1.7682,1.8274-5.3004,5.7984-6.4916V7.9357c0,0-0.0543-1.8766,1.7157-2.3308h0.6902 c1.7705,0.4541,1.716,2.3308,1.716,2.3308v2.3298c3.971,1.1912,5.3481,4.7234,5.7984,6.4916"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "3.1274,35.1152 3.1274,33.1647 11.3711,33.1647  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.1286,20.6925c2.7502,0.2471,3.478,3.0925,3.6717,4.6667"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.7015,25.3592c0.1952-1.5868,0.9327-4.4651,3.7369-4.6725"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "43.6291,32.1294 43.6291,27.9179 43.0019,26.3945 43.6291,26.3945 51.8728,26.3945 52.5,26.3945  51.8728,27.9179 51.8728,32.1294  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "17.106,36.1505 12.4063,36.1505 12.4063,42.607  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "42.5938,42.607 42.5938,36.1505 37.8945,36.1505  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "51.8728,35.1152 51.8728,33.1647 43.6291,33.1647  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "43.6291,36.1505 51.8728,36.1505 51.8728,42.607  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "23.23,36.1505 18.1414,36.1505 18.1414,42.607  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "36.8592,42.607 36.8592,36.1505 31.7697,36.1505  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "30.7345,42.607 30.7345,36.1505 24.2653,36.1505 24.2653,42.607  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 27.5,
    y1: 5.6049,
    x2: 27.5,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.7418,
    y1: 3.363,
    x2: 26.2584,
    y2: 3.363
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.4503,
    y1: 15.5029,
    x2: 7.4503,
    y2: 20.4311
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 47.751,
    y1: 15.5029,
    x2: 47.751,
    y2: 20.4311
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 32.0764,
    y1: 23.959,
    x2: 32.0764,
    y2: 27.828
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 30.2796,
    y1: 23.959,
    x2: 30.2796,
    y2: 27.828
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 28.4827,
    y1: 23.959,
    x2: 28.4827,
    y2: 27.828
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 26.6858,
    y1: 23.959,
    x2: 26.6858,
    y2: 27.828
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 24.8889,
    y1: 23.959,
    x2: 24.8889,
    y2: 27.828
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.092,
    y1: 23.959,
    x2: 23.092,
    y2: 27.828
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParlament);
export default __webpack_public_path__ + "static/media/parlament.07d8307a6ff198136b9c2bc0bce2e62b.svg";
export { ForwardRef as ReactComponent };